// A configuração DESTA tela — não da loja, não do usuário.
//
// Um restaurante tem vários monitores rodando o mesmo KDS: o do bar, o da
// cozinha, o da chapa. Cada um precisa abrir já filtrado no que é dele, e
// normalmente todos entram com o MESMO login da loja — então a escolha não
// pode morar no usuário. Ela mora no aparelho (localStorage), e existe um link
// direto pra deixar de atalho no tablet: /#/admin/kds?setor=<id>.
//
// A querystring ganha do que está guardado e é gravada por cima: abrir pelo
// atalho uma vez já deixa o aparelho configurado.
//
// Além do setor, a tela tem um MODO: "cozinha" (as colunas de produção) ou
// "garcom" (o que ficou pronto nas mesas, pra levar). O tablet do salão fica
// no modo garçom; o monitor da cozinha, no modo cozinha.

const CHAVE_SETOR = "kds:setor";
const CHAVE_MODO = "kds:modo";
const CHAVE_VISTA_GARCOM = "kds:garcom-vista";
export const MODOS = ["cozinha", "garcom"];
// No modo garçom a tela pode mostrar as duas colunas ou só uma — uma TV no
// salão só com "Para levar", por exemplo (pedido do dono).
export const VISTAS_GARCOM = ["todos", "paraLevar", "entregues"];

function ler(chave) {
  try { return window.localStorage.getItem(chave); } catch (_) { return null; }
}
function gravar(chave, valor) {
  try {
    if (valor == null) window.localStorage.removeItem(chave);
    else window.localStorage.setItem(chave, valor);
  } catch (_) { /* navegador sem storage: a tela só perde a memória */ }
}

/** Setor com que esta tela abre. `searchParams` vem do react-router. */
export function setorInicial(searchParams) {
  const daUrl = searchParams?.get("setor");
  if (daUrl) {
    gravar(CHAVE_SETOR, daUrl);
    return daUrl;
  }
  return ler(CHAVE_SETOR) || "todos";
}

/** Guarda a escolha no aparelho. "todos" apaga a preferência. */
export function guardarSetor(setor) {
  gravar(CHAVE_SETOR, setor && setor !== "todos" ? setor : null);
}

/** O setor guardado pode ter sido apagado no cadastro; nesse caso a tela
 *  volta pra "todos" em vez de ficar mostrando uma fila vazia pra sempre. */
export function setorValido(setor, setores) {
  if (!setor || setor === "todos") return "todos";
  return (setores || []).some((s) => s.id === setor) ? setor : "todos";
}

/** Modo com que esta tela abre: querystring, depois o aparelho, senão cozinha. */
export function modoInicial(searchParams) {
  const daUrl = searchParams?.get("modo");
  if (MODOS.includes(daUrl)) {
    gravar(CHAVE_MODO, daUrl);
    return daUrl;
  }
  const guardado = ler(CHAVE_MODO);
  return MODOS.includes(guardado) ? guardado : "cozinha";
}

export function guardarModo(modo) {
  gravar(CHAVE_MODO, MODOS.includes(modo) && modo !== "cozinha" ? modo : null);
}

export function vistaGarcomInicial(searchParams) {
  const daUrl = searchParams?.get("vista");
  if (VISTAS_GARCOM.includes(daUrl)) {
    gravar(CHAVE_VISTA_GARCOM, daUrl);
    return daUrl;
  }
  const guardada = ler(CHAVE_VISTA_GARCOM);
  return VISTAS_GARCOM.includes(guardada) ? guardada : "todos";
}

export function guardarVistaGarcom(vista) {
  gravar(CHAVE_VISTA_GARCOM, VISTAS_GARCOM.includes(vista) && vista !== "todos" ? vista : null);
}

/** Link pra deixar de atalho no aparelho daquela praça. */
export function linkDaTela(setor, modo = "cozinha", vista = "todos") {
  const base = `${window.location.origin}/#/admin/kds`;
  const qs = [];
  if (modo && modo !== "cozinha") qs.push(`modo=${modo}`);
  if (modo === "garcom" && vista && vista !== "todos") qs.push(`vista=${vista}`);
  if (setor && setor !== "todos") qs.push(`setor=${encodeURIComponent(setor)}`);
  return qs.length ? `${base}?${qs.join("&")}` : base;
}
